<mat-form-field class="allwidth">
  <mat-label>{{ placeholder ? (placeholder | translate) : ''}}</mat-label>
    <input matInput [value]="selectedItem?.[propertyToShow]" [disabled]="true" class="one">
      <i matSuffix *ngIf="ngControl?.control.enabled || enabled" class="glyphicon glyphicon-new-window link" (click)="selectItem()"></i>
</mat-form-field>
<error [control]="ngControl?.control" [checkForTouched]="false"></error>